import { render, staticRenderFns } from "./TableDeleted.vue?vue&type=template&id=0e08248e&scoped=true"
import script from "./TableDeleted.vue?vue&type=script&lang=js"
export * from "./TableDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e08248e",
  null
  
)

export default component.exports